import { render } from "./PortfolioValue.vue?vue&type=template&id=396cfbc2&ts=true"
import script from "./PortfolioValue.vue?vue&type=script&lang=ts"
export * from "./PortfolioValue.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__